import React from 'react';
function Underline({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M8 6V10.8462C8 11.9478 8.42143 13.0044 9.17157 13.7834C9.92172 14.5624 10.9391 15 12 15C13.0609 15 14.0783 14.5624 14.8284 13.7834C15.5786 13.0044 16 11.9478 16 10.8462V6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 18H17" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Underline;
